import React from 'react'

function DatePickerHeader() {

  return (
    <div className="mb-20 md:mb-32 pt-0">
      <p>Ticket prices vary by day and time. To save, choose a non-peak date for your visit.</p>
      <p>
        Programs and events may still be available if general admission is sold out.
      </p>
    </div>
  )
}

export default DatePickerHeader
